import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Sidebar from "../../components/dashboard/Sidebar";
import DashboardHeader from "../../components/dashboard/HeaderDashboard";
import StudyMetrics from "../../components/studyDetails/studyMetrics";
import StudySettings from "../../components/studyDetails/studySettings";
import MasterICFSettings from "../../components/studyDetails/masterICFsettings";
import SiteSettings from "../../components/studyDetails/SiteSettings";
import RoleManagement from "../../components/studyDetails/RoleManagements";
import StudyController from "@/network/controllers/study.controller";
import State, { STATE, CurrentEntityState, CurrentStudyState } from "@state";
import NavigationService from "@services/navigation.service.js";
import AuthController from "@controllers/auth.controller.js";

export default function StudyDetail() {
  const { id } = useParams();
  
  const [studyData, setStudyData] = useState({});
  const [studySettings, setStudySettings] = useState({});
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("Metrics");
  const [milestoneData, setMilestoneData] = useState([]);
  const [siteData, setSiteData] = useState([]);
  const [latestEnrolments, setLatestEnrolments] = useState([]);
  const [masterIcfMilestones, setMasterIcfMilestones] = useState([]);
  const [siteSettingsData, setSiteSettingsData] = useState([]);
  const [roleManagementData, setRoleManagementData] = useState({});

  const navLinks = [
    {
      name: "Dashboard",
      path: "/dashboard",
      icon: (
        <div className="w-8 h-8 flex items-center justify-center text-gray-500">
          <img
            src="/icons/sidebar/Dashboard 1.svg"
            alt="Support"
            className="w-6 h-6"
          />
        </div>
      ),
    },
    {
      name: "Settings",
      path: "/settings",
      icon: (
        <div className="w-8 h-8 flex items-center justify-center text-gray-500">
          <img
            src="/icons/sidebar/Setting 1.svg"
            alt="Support"
            className="w-6 h-6"
          />
        </div>
      ),
    },
    {
      name: "Notifications",
      path: "/notifications",
      icon: (
        <div className="w-8 h-8 flex items-center justify-center">
          <img
            src="/icons/sidebar/Notification 1.svg"
            alt="Support"
            className="w-6 h-6"
          />
        </div>
      ),
      badge: "4",
    },
    {
      name: "Support",
      path: "/support",
      icon: (
        <div className="w-8 h-8 flex items-center justify-center">
          <img
            src="/icons/sidebar/Support 1.svg"
            alt="Support"
            className="w-6 h-6"
          />
        </div>
      ),
    },
  ];

  const isClosed = studyData.status === "closed";

  useEffect(() => {
    console.log("StudyDetail activeTab:", activeTab);
  }, [activeTab]);

  useEffect(() => {
    setLoading(true);

    const fetchStudyData = async () => {
      try {
        const metricsResponse = await StudyController.getStudyMetricsCRO(id);
        if (metricsResponse && metricsResponse.success) {
          setMilestoneData(metricsResponse.data.milestone_progression);
          setSiteData(metricsResponse.data.eligible_participants_by_site);
        } else {
          console.error(
            "Error fetching metrics:",
            metricsResponse?.message || "Unknown error"
          );
          setMilestoneData([]);
          setSiteData([]);
        }

        const patientsResponse = await StudyController.getStudyPatientsCRO(id);

        if (Array.isArray(patientsResponse)) {
          setLatestEnrolments(patientsResponse);
        } else {
          console.error(
            "Error fetching latest enrolments:",
            patientsResponse?.message || "Unknown error"
          );
          setLatestEnrolments([]);
        }

        const generalSettingsResponse =
          await StudyController.getStudyGeneralSettingsCRO(id);
        console.log(
          "=== generalSettingsResponse === StudyDetails.jsx === key: 774375 ==="
        );
        console.dir(generalSettingsResponse, { depth: null, colors: true });
        console.log("=================================");

        if (
          generalSettingsResponse &&
          generalSettingsResponse?.success !== false
        ) {
          setStudySettings(generalSettingsResponse);

          const receivedStudy = generalSettingsResponse.study;
          if (receivedStudy) {
            setStudyData(receivedStudy);
          }
        } else {
          console.error(
            "Error fetching general settings:",
            generalSettingsResponse?.message || "Unknown error"
          );
          setStudySettings([]);
        }

        const masterIcfMilestonesResponse =
          await StudyController.getMasterIcfSettingsCRO(id);

        console.log(
          "=== masterIcfMilestonesResponse === StudyDetails.jsx === key: 337174 ==="
        );
        console.dir(masterIcfMilestonesResponse, { depth: null, colors: true });
        console.log("=================================");

        if (
          masterIcfMilestonesResponse &&
          masterIcfMilestonesResponse?.success !== false
        ) {
          const fetchedMilestones = masterIcfMilestonesResponse.data.map(
            (m) => ({
              id: m.id,
              number: m.milestone_number,
              name: m.milestone_name,
              description: m.milestone_description, 
              mandatory: m.mandatory === true, 
            })
          );
          setMasterIcfMilestones(fetchedMilestones);
          console.log(
            "masterIcfMilestonesResponse.data:",
            masterIcfMilestonesResponse.data
          );
          State.setValue(CurrentStudyState.MILESTONES, fetchedMilestones);
        } else {
          console.error(
            "Error fetching Master ICF milestones:",
            masterIcfMilestonesResponse?.message || "Unknown error"
          );
          setMasterIcfMilestones([]);
        }

        const siteSettingsResponse = await StudyController.getSiteSettingsCRO(
          id
        );
        if (siteSettingsResponse && siteSettingsResponse.success) {
          console.log(
            "StudyDetails:  site settings recu:",
            siteSettingsResponse.data
          );
          setSiteSettingsData(siteSettingsResponse.data);
        } else {
          console.error(
            "Error fetching site settings:",
            siteSettingsResponse?.message || "Unknown error"
          );
          setSiteSettingsData([]);
        }

        const roleManagementResponse =
          await StudyController.getRoleManagementCRO(id);
        console.log(
          ">> raw getRoleManagementCRO response:",
          roleManagementResponse
        );

        const roles = roleManagementResponse.data ?? roleManagementResponse;
        console.log(">> normalized roles object:", roles);

        console.log(
          "DEBUG StudyDetail: roles.study_manager from API is:",
          roles.study_manager
        );

        setRoleManagementData({
          study_manager: roles.study_manager || null,
          cro_invitations: roles.cro_invitations || [],
          investigator_invitations: roles.investigator_invitations || [],
        });

        State.setValue(CurrentStudyState.STUDY, {
          tmpId: id,
          name: generalSettingsResponse?.data?.study?.title || "",
        });
        State.setValue(
          CurrentStudyState.MASTER_ICFS,
          generalSettingsResponse?.data?.master_icfs || []
        );
        State.setValue(CurrentStudyState.MILESTONES, masterIcfMilestones || []);
        State.setValue(
          CurrentStudyState.SITES,
          siteSettingsResponse?.data || []
        );
        State.setValue(
          CurrentStudyState.CRO_MANAGERS,
          roles.cro_invitations || []
        );
        State.setValue(
          CurrentStudyState.INVESTIGATORS,
          roles.investigator_invitations || []
        );
      } catch (error) {
        console.error(
          "Network or unexpected error fetching study data:",
          error
        );
        setStudyData({ title: "Study Details" });
        setMilestoneData([]);
        setSiteData([]);
        setLatestEnrolments([]);
        setStudySettings([]);
        setMasterIcfMilestones([]);
        setSiteSettingsData([]);
        setRoleManagementData({
          study_manager: null,
          cro_invitations: [],
          investigator_invitations: [],
        });
      } finally {
        setLoading(false);
      }
    };

    fetchStudyData();
  }, [id]);

  const handleCreateStudy = () => {
    NavigationService.navigateTo("/create-study");
  };

  const handleSignOut = () => {
    AuthController.logout();
  };

  const handleUpdateStudy = async (updatedStudy) => {
    if (updatedStudy) {
      console.log("🔁 Received updated study from child:", updatedStudy);
      setStudyData(updatedStudy); 
    }
  
    try {
      const generalSettingsResponse =
        await StudyController.getStudyGeneralSettingsCRO(id);

      console.log('=== generalSettingsResponse === StudyDetails.jsx === key: 512975 ===');
      console.dir(generalSettingsResponse, { depth: null, colors: true })
      console.log('=================================');

      if (generalSettingsResponse?.success !== false) {
        setStudySettings(generalSettingsResponse);
        const receivedStudy = generalSettingsResponse.study;
        if (receivedStudy) {
          setStudyData(receivedStudy);
        }
      } else {
        console.log('=== generalSettingsResponse === StudyDetails.jsx === key: 827027 ===');
        console.dir(generalSettingsResponse, { depth: null, colors: true })
        console.log('=================================');
      }
    } catch (error) {
      console.log('=== error === StudyDetails.jsx === key: 750363 ===');
      console.dir(error, { depth: null, colors: true })
      console.log('=================================');
    }
  };

  const onCloseStudy = () => {
    console.log("Study closed");
    setStudyData((prev) => ({ ...prev, status: "closed" }));
  };

  if (loading) {
    return (
      <div className="flex h-screen bg-dashboard-bg">
        <Sidebar
          title="OSHIMED"
          navLinks={navLinks}
          activeLink="Dashboard"
          companyName="Company Name"
          onCreateStudy={handleCreateStudy}
          onSignOut={handleSignOut}
        />
        <div className="flex-1 flex flex-col overflow-hidden p-4">
          <DashboardHeader title="Loading..." buttons={[]} />
          <div className="flex-1 mt-2 rounded-xl overflow-auto bg-[#F5F8FF] flex items-center justify-center">
            <div className="text-xl text-gray-600">
              Loading study details...
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!studyData) {
    return (
      <div className="flex h-screen p-20 bg-dashboard-bg">
        <Sidebar
          title="OSHIMED"
          navLinks={navLinks}
          activeLink="Dashboard"
          companyName="Company Name"
          onCreateStudy={handleCreateStudy}
          onSignOut={handleSignOut}
        />
        <div className="flex-1 flex flex-col overflow-hidden p-4">
          <DashboardHeader title="Studio non trovato" buttons={[]} />
          <div className="flex-1 mt-2 rounded-xl overflow-auto flex items-center justify-center">
            <div className="text-xl text-gray-600">Study not found</div>
          </div>
        </div>
      </div>
    );
  }

  const tabButtons = [
    "Metrics",
    "Study settings",
    "Master ICF settings",
    "Site settings",
    "Role management",
  ];

  return (
    <div className="flex h-screen bg-dashboard-bg">
      <Sidebar
        title="OSHIMED"
        navLinks={navLinks}
        activeLink="Dashboard"
        companyName="Company Name"
        onCreateStudy={handleCreateStudy}
        onSignOut={handleSignOut}
      />
      <div className="flex-1 flex flex-col overflow-hidden bg-dashboard-bg">
        <DashboardHeader
          title={studyData.name}
          buttons={tabButtons}
          activeButton={activeTab}
          onButtonClick={(tab) => {
            console.log("Setting activeTab to:", tab);
            setActiveTab(tab);
          }}
        />
        <div className="flex-1 overflow-auto bg-dashboard-bg">
          <main className="p-6">
            {activeTab === "Metrics" && (
              <StudyMetrics
                milestoneData={milestoneData}
                siteData={siteData}
                latestEnrolments={latestEnrolments}
              />
            )}
            {activeTab === "Study settings" && (
              <StudySettings
                study={studyData}
                settings={studySettings}
                onUpdateStudy={handleUpdateStudy}
                onCloseStudy={onCloseStudy}
                isClosed={isClosed}
              />
            )}
            {activeTab === "Master ICF settings" && (
              <MasterICFSettings
                study={{ ...studyData, masterICF: studySettings.master_icfs }}
                milestones={masterIcfMilestones}
                onUpdateStudy={handleUpdateStudy}
                isClosed={isClosed}
              />
            )}
            {activeTab === "Site settings" && (
              <SiteSettings
                study={{
                  ...studyData,
                  masterICF: studySettings.master_icfs,
                  sites: siteSettingsData,
                }}
                siteSettings={siteSettingsData}
                isClosed={isClosed}
                onUpdateStudy={(updatedStudy) => {
                  setSiteSettingsData(updatedStudy.sites || []);
                  setStudyData((prev) => ({
                    ...prev,
                    sites: updatedStudy.sites || [],
                  }));
                  handleUpdateStudy(updatedStudy); 
                }}
              />
            )}
            {activeTab === "Role management" && (
              <RoleManagement
                study={studyData}
                roleManagementData={roleManagementData}
                availableSites={siteSettingsData}
                isClosed={isClosed}
                onUpdateStudy={(updatedStudy) => {
                  setStudyData((prev) => ({ ...prev, ...updatedStudy }));
                  console.log(
                    "Study updated from Role Management:",
                    updatedStudy
                  );
                }}
              />
            )}
          </main>
        </div>
      </div>
    </div>
  );
}
